import { render, staticRenderFns } from "./res-banner.mpx?vue&type=template&id=23e5118e&scoped=true&isComponent&outputPath=components%2Fres-banner12bfcde6%2Findex"
import script from "./res-banner.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fres-banner12bfcde6%2Findex"
export * from "./res-banner.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fres-banner12bfcde6%2Findex"
import style0 from "./res-banner.mpx?vue&type=style&index=0&id=23e5118e&prod&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m12bfcde6%22%7D&isComponent&outputPath=components%2Fres-banner12bfcde6%2Findex"
import style1 from "./res-banner.mpx?vue&type=style&index=1&id=23e5118e&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22m12bfcde6%22%7D&isComponent&outputPath=components%2Fres-banner12bfcde6%2Findex"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e5118e",
  null
  
)

export default component.exports